var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-list2',{attrs:{"conditions":_vm.conditions,"msg":'30,500 作者'},on:{"handleClickItem":_vm.handleClickDynasty,"handleClickUnlimit":_vm.handleClickUnlimit}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aecd3552","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav_author/AuthorDynastyList.vue
// module id = 1619
// module chunks = 0